import {
  SvgIcon,
  Container,
  Toolbar,
  Box,
  AppBar as MUIAppBar,
  Link,
} from '@mui/material'

import logoPNG from 'assets/img/logo-new.png'
import { ReactComponent as LogoOrangeSVG } from 'assets/svg/logo_orange.svg'

interface Props {
  variant?: string
}

const AppBar = (props: Props) => {
  const { variant } = props

  const IS_VARIANT_INNER = variant === 'inner'

  return (
    <MUIAppBar
      position="static"
      sx={{
        backgroundColor: IS_VARIANT_INNER ? 'primary.main' : 'common.white',
        p: 0,
      }}
    >
      <Container maxWidth="xl">
        <Toolbar disableGutters>
          <Link
            href={process.env.REACT_APP_REDIRECT_SEARCH_APP_URL}
            underline="none"
          >
            <Box sx={{ mb: -3, pt: 1, cursor: 'pointer' }}>
              {IS_VARIANT_INNER ? (
                <SvgIcon
                  component={LogoOrangeSVG}
                  inheritViewBox
                  sx={{
                    width: 'auto',
                    height: { xs: 50, sm: 90, md: 100, lg: 136 },
                    fill: 'black',
                  }}
                />
              ) : (
                <Box
                  component="img"
                  src={logoPNG}
                  alt="logo"
                  sx={{
                    width: 'auto',
                    height: { xs: 50, sm: 90, md: 100, lg: 136 },
                  }}
                />
              )}
            </Box>
          </Link>

          <Box sx={{ flexGrow: 1, display: { xs: 'flex', md: 'flex' } }}></Box>
        </Toolbar>
      </Container>
    </MUIAppBar>
  )
}
export default AppBar
